
import React, { useState } from 'react';
import HeaderOne from "../components/header/HeaderOne";
import FooterTwo from "../components/footer/FooterTwo";
import Breadcrumb from "./Breadcrumb";
import BlogGridMain from './BlogGridMain';
import EmersonHeader from '../components/header/EmersonHeader';
import BlogListMain from './BlogListMain';
import { generateSlug, useBlogs } from '../services/blogService';

function BlogGrid() {
    const { data: blogs = [], isLoading } = useBlogs();
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 9; // 3 columns x 3 rows

    const breadcrumbs = [
        { label: 'Home', link: '/' },
        { label: 'Latest Blogs' }
    ];

    // Calculate pagination
    const totalPages = Math.ceil(blogs.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentBlogs = blogs.slice(startIndex, endIndex);

    // Handle page change
    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
            // Scroll to top of blog section
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    // Generate page numbers to display
    const getPageNumbers = () => {
        const pages = [];
        const maxVisiblePages = 4;
        
        if (totalPages <= maxVisiblePages) {
            // Show all pages if total is less than max
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            // Show first page
            pages.push(1);
            
            // Show pages around current page
            const start = Math.max(2, currentPage - 1);
            const end = Math.min(totalPages - 1, currentPage + 1);
            
            if (start > 2) {
                pages.push('...');
            }
            
            for (let i = start; i <= end; i++) {
                if (i !== 1 && i !== totalPages) {
                    pages.push(i);
                }
            }
            
            if (end < totalPages - 1) {
                pages.push('...');
            }
            
            // Show last page
            if (totalPages > 1) {
                pages.push(totalPages);
            }
        }
        
        return pages;
    };

    return (
        <div>
            <EmersonHeader />

            <Breadcrumb title="Latest Blogs" breadcrumbs={breadcrumbs} />

            <div className="rts-blog-grid-area rts-section-gap">
                <div className="container">
                    <div className="row g-5">
                        <div className="col-xl-12 col-md-12 col-sm-12 col-12 pr--40 pr_md--0 pr_sm-controler--0">
                            {isLoading ? (
                                <div className="text-center py-5">
                                    <p>Loading blogs...</p>
                                </div>
                            ) : currentBlogs.length > 0 ? (
                                <>
                                    <div className="row g-5">
                                        {currentBlogs.map((data, index) => (
                                            <div key={data.id || index} className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                                                <div className="blog-grid-inner">
                                                    <BlogListMain
                                                        blogID={generateSlug(data.title)}
                                                        blogImage={data.image}   
                                                        blogTitle={data.title}
                                                        blogCategory={data.category}
                                                        blogPublishedDate={data.publishedDate}
                                                    />
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    {/* pagination area */}
                                    {totalPages > 1 && (
                                        <div className="row mt--30">
                                            <div className="col-12">
                                                <div className="text-center">
                                                    <div className="pagination">
                                                        {/* Previous button */}
                                                        <button 
                                                            onClick={() => handlePageChange(currentPage - 1)}
                                                            disabled={currentPage === 1}
                                                            className={currentPage === 1 ? 'disabled' : ''}
                                                            style={{ opacity: currentPage === 1 ? 0.5 : 1, cursor: currentPage === 1 ? 'not-allowed' : 'pointer' }}
                                                        >
                                                            <i className="fal fa-angle-double-left" />
                                                        </button>

                                                        {/* Page numbers */}
                                                        {getPageNumbers().map((page, index) => (
                                                            page === '...' ? (
                                                                <span key={`ellipsis-${index}`} style={{ padding: '15px', marginRight: '10px' }}>...</span>
                                                            ) : (
                                                                <button
                                                                    key={page}
                                                                    onClick={() => handlePageChange(page)}
                                                                    className={currentPage === page ? 'active' : ''}
                                                                >
                                                                    {String(page).padStart(2, '0')}
                                                                </button>
                                                            )
                                                        ))}

                                                        {/* Next button */}
                                                        <button 
                                                            onClick={() => handlePageChange(currentPage + 1)}
                                                            disabled={currentPage === totalPages}
                                                            className={currentPage === totalPages ? 'disabled' : ''}
                                                            style={{ opacity: currentPage === totalPages ? 0.5 : 1, cursor: currentPage === totalPages ? 'not-allowed' : 'pointer' }}
                                                        >
                                                            <i className="fal fa-angle-double-right" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </>
                            ) : (
                                <div className="text-center py-5">
                                    <p>No blogs available at the moment.</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <FooterTwo />
        </div>
    );
}

export default BlogGrid;